// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__y6ilD","icon":"SortAdornment_icon__3aGgj","up":"SortAdornment_up__33kKD","down":"SortAdornment_down__19UrY","active":"SortAdornment_active__2EWEW"};